import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const HeroSlider = ({ subheading, heading, image, paragraph, sliderRef }) => {
  return (
    <>
      <button
        onClick={() => sliderRef.current.slickPrev()}
        className="absolute top-[50%] left-3  border border-slate-300 cursor-pointer  px-3 bg-slate-300 hover:bg-black hover:text-white hover:border-black py-2 text-2xl"
      >
        <IoIosArrowBack />
      </button>
      <button
        onClick={() => sliderRef.current.slickNext()}
        className="  absolute top-[50%] right-3  border  border-slate-300 cursor-pointer px-3 bg-slate-300 hover:bg-black hover:text-white hover:border-black py-2 text-2xl "
      >
        <IoIosArrowForward />
      </button>
      <div className=" group grid grid-cols-1 lg:grid-cols-6  h-[70vh]  px-[30px] md:px-[40px] lg:px-[7%]">
        <div className=" flex flex-col justify-center lg:justify-start col-span-4 lg:pt-32 ">
          <h4 className=" font-extrabold text-base  text-slate-200  ">
            {subheading}
          </h4>

          <h1
            data-aos="fade-left"
            className=" text-white pt-5 text-5xl  font-extrabold"
          >
            {heading}
          </h1>
          <p className=" text-sm  text-slate-100 pt-5 mr-20">{paragraph}</p>
        </div>
        <div className=" hidden lg:flex flex-col justify-end col-span-2 ">
          <img src={`${image}`} alt="" />
        </div>
      </div>
    </>
  );
};

export default HeroSlider;
